import { render, staticRenderFns } from "./KilkayaFeed.vue?vue&type=template&id=0778aea1"
import script from "./KilkayaFeed.vue?vue&type=script&lang=ts"
export * from "./KilkayaFeed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports